export const INCUBATOR_INITIAL_PRESET_FIELDS = [
    'delay_for_bets_time',
    'coef_changing',
    'consider_personal_limits',
    'hide_creator'
] as const;

export type IncubatorInitialPresetField = typeof INCUBATOR_INITIAL_PRESET_FIELDS[number];

export interface IncubatorInitialPresetsShape {
    coef_changing: number
    consider_personal_limits: boolean
    delay_for_bets_time: number
    hide_creator: boolean
}

export const isIncubatorInitialPresetField =
 (key: string): key is IncubatorInitialPresetField => (INCUBATOR_INITIAL_PRESET_FIELDS as readonly string[]).includes(key);

export const isIncubatorInitialPresetFieldErrors = (
    json: unknown
): json is Record<IncubatorInitialPresetField, string[]> => {
    if (!json || typeof json !== 'object' || Array.isArray(json)) {
        return false;
    }

    const keys = Object.keys(json);

    return keys.length > 0 && keys.every(isIncubatorInitialPresetField);
};
